// =======================
// == Animations/App.js ==
// =======================
/*
  All of the animations for app.js
*/

import Animator from './animator';

const complete = () => {
  // We cannot let #topbar maintain any inline `transform`
  // after the animation has occured because these interfere
  // with fixed position children.  See:
  // https://stackoverflow.com/questions/15194313/transform3d-not-working-with-position-fixed-children
  document.getElementById('topbar').style = '';
};

const animate = () => {
  //console.log('Animating App Load');
  new Animator()
    .fadeIn('#title', {
      offset: 0,
      translateY: [{ value: 15, duration: 0 }, { value: 1, duration: 500 }],
    })
    .fadeIn('#subtitle')
    .fadeIn('#footer')
    .fadeIn('#searchForm', { offset: '-=1000' })
    .finished.then(complete);
};

export default animate;
